import { createFileRoute } from "@tanstack/react-router";
import { toast } from "sonner";
import { useRequireRole } from "@/lib/use-require-role";
import { PageHeader } from "@/components/page-header";
import { Button } from "@/components/ui/button";
import { organizations, fmtCents } from "@/mocks/saas-data";

export const Route = createFileRoute("/admin/billing")({
  ssr: false,
  head: () => ({ meta: [{ title: "Admin — Billing" }] }),
  component: Page,
});

const failed = [
  { id: "f1", orgId: "org_4", amountCents: 8900, reason: "card_declined", at: "2026-06-02" },
  { id: "f2", orgId: "org_3", amountCents: 2900, reason: "expired_card", at: "2026-05-29" },
];

function Page() {
  const user = useRequireRole(["superadmin"]);
  if (!user) return null;
  return (
    <div className="mx-auto max-w-5xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader title="Billing" description="Failed charges, refunds, manual credits." />
      <h2 className="mb-3 text-xs font-semibold uppercase tracking-widest text-muted-foreground">Failed charges</h2>
      <div className="overflow-hidden rounded-xl bg-card ring-1 ring-border">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-border bg-surface-muted/50">
            <tr className="text-[11px] uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3 font-medium">Organization</th>
              <th className="px-4 py-3 font-medium">Amount</th>
              <th className="px-4 py-3 font-medium">Reason</th>
              <th className="px-4 py-3 font-medium">Date</th>
              <th className="px-4 py-3 text-right font-medium">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {failed.map((f) => {
              const org = organizations.find((o) => o.id === f.orgId);
              return (
                <tr key={f.id}>
                  <td className="px-4 py-3 font-medium">{org?.name ?? "—"}</td>
                  <td className="px-4 py-3 font-mono">{fmtCents(f.amountCents)}</td>
                  <td className="px-4 py-3 font-mono text-[11px] text-muted-foreground">{f.reason}</td>
                  <td className="px-4 py-3 font-mono text-[11px] text-muted-foreground">{f.at}</td>
                  <td className="px-4 py-3 text-right">
                    <Button size="sm" variant="outline" onClick={() => toast.success("Retry queued")}>Retry charge</Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
